import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getNotifications = async (limit = 50) => {
  try {
    const response = await fetch(`${API_URL}/api/notifications?limit=${limit}`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) {
      return { items: [], total: 0 };
    }
    return response.json();
  } catch (error) {
    return { items: [], total: 0 };
  }
};

export const getNotificationCount = async () => {
  try {
    const response = await fetch(`${API_URL}/api/notifications/count`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      return { new_photos: 0, total_shared_with_you: 0 };
    }
    
    return response.json();
  } catch (error) {
    return { new_photos: 0, total_shared_with_you: 0 };
  }
};

export const markNotificationsSeen = async () => {
  try {
    const response = await fetch(`${API_URL}/api/notifications/mark-seen`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Failed to mark notifications');
    }
    
    return response.json();
  } catch (error) {
    throw error;
  }
};
